/**
 * API 加密配置
 * 定义需要加密和不需要加密的接口
 */

/**
 * 需要加密的 apiWord 模块路由
 * 这些接口将使用 RSA+AES-GCM 混合加密
 */
export const API_WORD_ROUTES = [
  // 控制台相关
  "/indexByBlockWatch",
  "/apiMember",
  "/getEmailCode",
  "/validSecondAuth",

  // Google验证
  "/getGoogleAuthStatus",
  "/getGoogleAuth",
  "/setGoogleAuth",

  // 白名单管理
  "/getWhiteList",
  "/addWhiteList",
  "/updateWhiteList",

  // 交易回调
  "/getCallbackList",
  "/callbackReissue",

  // 资产管理
  "/getPocketList",
  "/getConfigList",
  "/getPocketInfo",
  "/addPocketAddress",
  "/updatePocketAddress",
  "/updateAddress",
  "/withdrawToCollect",

  // 合约配置
  "/listContractConfig",
  "/createContractConfig",
  "/updateContractConfig",
  "/deleteContractConfig",
  "/contractLogs",

  // 代币管理
  "/getAllTokenList",
  "/getUserTokens",
  "/addToken",
  "/editToken",
  "/delToken",
  "/addApplyToken",
  "/getApplyTokenList",

  // 充币管理
  "/getUpCoinList",
  "/setTransactionInfo",

  // 归集操作
  "/manualCollection",
  "/oneClickCollection",

  // 提币审核
  "/withdrawList",
  "/getVerifyStatus",
  "/setVerifyStatus",
  "/changeWithdrawStatus",

  // 提现配置
  "/getWithdrawConfig",
  "/updateWithdrawConfig",
  "/addWithdrawConfig",

  // 地址管理
  "/getUserAddress",
  "/generateAddress",
  "/updateCallBackUrl",
  "/allowAddress",
  "/banAddress",
];

/**
 * 白名单路由 - 不需要加密的接口
 * 这些接口使用现有的签名验证机制
 * 注意：使用完整路径，避免部分匹配导致误判
 */
export const WHITE_LIST_ROUTES = [
  "/generateAddress", // 生成地址
  "/productUpgrade", // 产品升级回调
  "/withdraw", // 提币申请（完整路径，避免匹配到 /withdrawToCollect）
  "/delAddress", // 删除地址
  "/withdrawContract", // 合约提现
  "/withdrawContractNft", // NFT合约提现
];

/**
 * 判断路由是否需要加密
 * @param {string} url - 请求URL
 * @returns {boolean} 是否需要加密
 */
export function shouldEncrypt(url) {
  //1. 检查是否是 apiWord 模块的路由
  const isApiWordRoute = API_WORD_ROUTES.some((route) => url.includes(route));

  if (!isApiWordRoute) {
    return false;
  }

  //2. 检查是否在白名单中（精确匹配或完整路径匹配）
  // 先尝试精确匹配
  const isExactMatch = WHITE_LIST_ROUTES.includes(url);
  if (isExactMatch) {
    return false;
  }

  // 再尝试包含匹配（但确保不是部分匹配）
  const isWhiteList = WHITE_LIST_ROUTES.some((route) => {
    // 确保是完整的路径匹配，而不是部分字符串匹配
    return url === route || url.startsWith(route + "/");
  });

  return !isWhiteList;
}
